module.exports = __webpack_public_path__ + "img/anaqueles_hardselzers.e0d85805.png";